export function intersectionObserver(node, { callback, options, querySelectorAll }) {
    const observer = new IntersectionObserver(callback, options);
    const nodes = querySelectorAll ? node.querySelectorAll(querySelectorAll) : [node];
    nodes.forEach((n) => {
        observer.observe(n);
    });
    return {
        destroy() {
            observer.disconnect();
        }
    };
}
